import { type AxiosResponse } from 'axios';

import { get, post, put } from '@utilities';

export const fetchProjectCosts = async (): Promise<AxiosResponse> => await get('/dashboard/project-costs');
export const fetchProjectOverview = async (): Promise<AxiosResponse> => await get('/dashboard/project-overview');
export const fetchStatusSummary = async (): Promise<AxiosResponse> => await get('/dashboard/status-summary');
export const fetchDashboardProjects = async (data: Record<string, any>): Promise<AxiosResponse> => await post('project/all', data);
export const fetchDashboardApprovals = async (data: Record<string, any>): Promise<AxiosResponse> => await post('approval/all', data);
export const fetchApprovalDocuments = async (data: Record<string, any>): Promise<AxiosResponse> => await post(`document/all`, data);
export const fetchDashboardTickets = async (data: Record<string, any>): Promise<AxiosResponse> => await post('ticket/all', data);
export const generatePromoCode = async (leadId: number): Promise<AxiosResponse> =>
	await get(`promo-code?lead_id=${leadId}`);
export const fetchPromoCodeHistory = async (): Promise<AxiosResponse> => await get('promo-code/history');
export const createCustomPromoCode = async (data: Record<string, any>): Promise<AxiosResponse> => await post('promo-code/custom', data);

export const togglePromoActive = async (promo_code: string, active: boolean): Promise<AxiosResponse> =>
	await put('promo-code/toggle-active', { promo_code, active });

export const fetchAnalyticsData = async (): Promise<AxiosResponse> => await get('/dashboard/analytics');
export const fetchFinancialData = async (): Promise<AxiosResponse> => await get('/dashboard/financial');
export const fetchCRMData = async (): Promise<AxiosResponse> => await get('/dashboard/crm');
export const fetchExecutiveData = async (): Promise<AxiosResponse> => await get('/dashboard/executive');
